import React from "react";

import AboutArea from "../components/AboutArea";
import Banner from "../components/Banner";
import BrandArea from "../components/BrandArea";
import ContactArea from "../components/ContactArea";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import ServiceArea from "../components/ServiceArea";
import ServiceAreaGroupFive from "../components/ServiceAreaGroupFive";
import WhoWeAreArea from "../components/WhoWeAreArea";
import WorkProcess from "../components/WorkProcess";

const Home = () => {
  return (
    <React.Fragment>
      <Navbar />
      <Banner />
      <WhoWeAreArea />
      <AboutArea />
      <BrandArea />
      <ServiceAreaGroupFive />
      <ServiceArea />
      <WorkProcess />
      {/* <ServiceAreaGroupTwo /> */}
      <ContactArea />
      <Footer />
    </React.Fragment>
  );
};

export default Home;
